import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {AuthCheck} from '../../helpers'
import {
  SearchInvoiceClient,
  GetInvoiceClient,
  SendInvoiceClient,
  GetDocumentPdfClient,
  GetInvoicePdfClient,
} from '../../api'

const SERVICE_URL = window.ENVVARS.REACT_APP_SERVICE_URL

// API Clients
const searchInvoiceClient = new SearchInvoiceClient(SERVICE_URL)
const getInvoiceClient = new GetInvoiceClient(SERVICE_URL)
const sendInvoiceClient = new SendInvoiceClient(SERVICE_URL)
const getDocumentPdfClient = new GetDocumentPdfClient(SERVICE_URL)
const getInvoicePdfClient = new GetInvoicePdfClient(SERVICE_URL)

const initialState = {
  loading: false,
  isRedirect: false,
  error: null,
  isDeleted: false,
  isArchived: false,
  isSent: false,
  documentdata: null,
  pdfdata: null,
  detail: null,
  gibinvoice: null,
}

// Async Thunks
export const gibinvoiceGetAll = createAsyncThunk(
  'gibinvoice/getAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await searchInvoiceClient.search(
        params.name,
        params.items_per_page,
        params.page,
        params.order,
        params.sort
      )
      dispatch(setGibInvoiceList(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const gibinvoiceGetId = createAsyncThunk('gibinvoice/getById', async (id, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    const response = await getInvoiceClient.get(id)
    dispatch(setDetail(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const gibinvoiceSend = createAsyncThunk('gibinvoice/send', async (id, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    const response = await sendInvoiceClient.send(id)
    dispatch(setSent(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const gibinvoiceGetDocumentPdf = createAsyncThunk(
  'gibinvoice/getDocumentPdf',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getDocumentPdfClient.getDocumentPdf(params.uuid, params.documentType)
      dispatch(setDocumentData(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const gibinvoiceGetInvoicePdf = createAsyncThunk(
  'gibinvoice/getInvoicePdf',
  async (id, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getInvoicePdfClient.getPdf(id)
      dispatch(setPdfData(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

// Slice
const gibinvoiceSlice = createSlice({
  name: 'gibinvoice',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setGibInvoiceList: (state, action) => {
      state.gibinvoice = action.payload
      state.loading = false
    },
    setDetail: (state, action) => {
      state.detail = action.payload
      state.loading = false
    },
    setSent: (state, action) => {
      state.isSent = action.payload
      state.loading = false
    },
    setDocumentData: (state, action) => {
      state.documentdata = action.payload
      state.loading = false
    },
    setPdfData: (state, action) => {
      state.pdfdata = action.payload
      state.loading = false
    },
    resetState: (state) => {
      Object.assign(state, initialState)
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('gibinvoice/') && action.type.endsWith('/pending'),
      (state) => {
        state.loading = true
      }
    )
  },
})

// Export actions
export const {
  setLoading,
  setError,
  setGibInvoiceList,
  setDetail,
  setSent,
  setDocumentData,
  setPdfData,
  resetState,
} = gibinvoiceSlice.actions

// Selectors
export const selectGibInvoiceLoading = (state) => state.gibinvoice.loading
export const selectGibInvoiceError = (state) => state.gibinvoice.error
export const selectGibInvoiceList = (state) => state.gibinvoice.gibinvoice
export const selectGibInvoiceDetail = (state) => state.gibinvoice.detail
export const selectGibInvoiceIsSent = (state) => state.gibinvoice.isSent
export const selectGibInvoiceDocumentData = (state) => state.gibinvoice.documentdata
export const selectGibInvoicePdfData = (state) => state.gibinvoice.pdfdata

export default gibinvoiceSlice.reducer
